import { Hero } from './Hero/Hero';
import { Upcoming } from './upcoming/Upcoming';
export const WorkshopsPage = () => {
  return (
    <>
      <Hero />
      <Upcoming />
    </>
  );
};
